var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"eb3d642f7bbb2499f543a04f0271d27ba4a82d75"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@pawp"]={id:"eb3d642f7bbb2499f543a04f0271d27ba4a82d75"};
      